import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@asambleas-env/environment';
import { UserFeedbackService } from '@asambleas-modules/user-feedback/user-feedback.service';

@Injectable()
export class MemberService {

    constructor(
        public http: HttpClient,
        private _feedback: UserFeedbackService
    ) { }

    getMembers() {
        let token = localStorage.getItem('id_token');
        return this.http.get(environment.apiEndPoint + '/miembros', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json charset=utf-8',
                'Authorization': token
            }
        });
    }

    getUser() {
        return JSON.parse(localStorage.getItem("user"));
    }

    update() {
        window.alert('Actualizar el usuario en el storage que en realidad debio ser un servicio con la información')
    }

    // Esta función modifica el is_academic de un usuario
    changeIsAcademic(member: any): Promise<boolean | any> {
        return new Promise((resolve, reject) => {
            let dialog = this._feedback.openDialog({
                title: 'Cambiar Role',
                body: `Mediante esta opción invertirás la opción de Ministro a Miembro o viceversa del usuario ${member.name}. Para continuar con el cambio, preciona aceptar, de lo contrario oprime cancelar.`,
                type: 'confirm'
            })
            dialog.afterClosed().subscribe(resp => {
                if (resp) {
                    let token = localStorage.getItem('id_token');
                    this.http.post(environment.apiEndPoint + '/miembros/changeIsAcademic', { 'id': member.id }, {
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json charset=utf-8',
                            'Authorization': token
                        }
                    }).subscribe((response) => {
                        resolve(true)
                    }, error => {
                        reject('Error en la petición al servidor')
                    })
                } else {
                    reject(false)
                }
            })
        });

    }

}



// WEBPACK FOOTER //
// ./src/app/services/member/member.service.ts